<template>
  <span>
    {{ percent | number('0.00') }}%
  </span>
</template>

<script>
import currency from 'currency.js';

export default {
  props: {
    totalizadores: Object,
    fornecedor: Object,
    property: {
      type: String,
      required: true,
    },
  },
  computed: {
    percent() {
      if (!this.totalizadores || !this.fornecedor) {
        return 0;
      }
      return currency(this.fornecedor[this.property])
        .multiply(100)
        .divide(currency(this.totalizadores[this.property]));
    },
  },
};
</script>
